import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';

import { Subscription } from 'rxjs';

import { Store } from '@ngrx/store';

import { PairChallenge } from '@rocksoft/settings-sdk';

import { PairingRouterStoreSelectors } from '@era/stores';
import { SkSpinner3Component } from '@rocksoft/cdk';
import { environment } from '@rocksoft/environment';
import { PairingStoreActions, PairingStoreSelectors } from '../../../sub-features/device-pairing/pairing-store';
import { PairingChallengeComponent } from './pairing-challenge.component';

@Component({
  selector: 'era-pairing-challenge',
  templateUrl: './pairing-challenge.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PairingChallengeComponent, SkSpinner3Component],
})
export class PairingChallengeContainerComponent {
  private readonly store = inject(Store);

  public readonly isVerifyingCode = this.store.selectSignal(PairingStoreSelectors.isVerifyingCode);
  public readonly isCodeInvalid = this.store.selectSignal(PairingStoreSelectors.isCodeInvalid);
  public readonly isEnrolling = this.store.selectSignal(PairingStoreSelectors.isEnrolling);
  public readonly isEnrollCompleted = this.store.selectSignal(PairingStoreSelectors.isEnrollmentCompleted);
  public readonly pairingChallenge = this.store.selectSignal(PairingStoreSelectors.selectPairChallenge);
  public readonly error = this.store.selectSignal(PairingStoreSelectors.selectError);
  public readonly pairingCode = this.store.selectSignal(PairingRouterStoreSelectors.selectPairingCode);
  public readonly environment = environment;

  private readonly subscriptions: Subscription[] = [];

  constructor() {
    effect(() => {
      const pairingCode = this.pairingCode();
      if (pairingCode) {
        this.store.dispatch(PairingStoreActions.PairConfirmContainerActions.verifyCodeRequested({ code: pairingCode }));
      }
    });
  }

  enroll(challenge: PairChallenge) {
    if (challenge?.challenge) {
      this.store.dispatch(
        PairingStoreActions.PairConfirmContainerActions.enrollmentRequested({ challenge: challenge.challenge })
      );
    }
  }

  get ca(): string {
    if (environment.local) {
      const url = new URL(`${environment.mdm.api}/ca`);
      url.hostname = window.location.hostname;
      return url.href;
    }
    return '';
  }
}
